import React from 'react';

import Button from '@material-ui/core/Button';
import { createStyles, WithStyles, withStyles } from '@material-ui/core/styles';
import FilterListIcon from '@material-ui/icons/FilterList';
import LockIcon from '@material-ui/icons/Lock';
import classnames from 'classnames';
import { LumaTheme } from 'embeds/core/styles/getTheme';

import { useDialogContext } from '../FiltersDialogContext';

const styles = ({
  custom: {
    palette: { colorLightBlue, colorSupportPowder, colorSupportSnow, colorAccentSunrise },
  },
  palette: {
    common: { white },
  },
  spacing: { unit },
}: LumaTheme) =>
  createStyles({
    filtersButton: {
      backgroundColor: white,
      border: `solid 1px ${colorLightBlue}`,
      float: 'right',
      height: 40,
      position: 'relative',
      '&:hover': {
        backgroundColor: colorSupportSnow,
      },
      '&$filtersSelected': {
        backgroundColor: colorSupportPowder,
      },
      '&$filtersSelectedSecondary': {
        backgroundColor: colorAccentSunrise,
      },
    },
    filtersButtonLabel: {
      fontSize: 17,
      fontWeight: 500,
      '&$filtersLabelLocked': {
        fontWeight: 600,
      },
    },
    filtersButtonIcon: {
      marginRight: unit,
    },
    lockedFiltersIcon: {
      width: 18,
      position: 'absolute',
      top: 10,
      left: 36,
    },
    rounded: {
      borderRadius: 5,
    },
    filtersSelected: {},
    filtersSelectedSecondary: {},
    filtersLabelLocked: {},
  });

interface FiltersButtonProps extends WithStyles<typeof styles> {
  color?: 'default' | 'secondary';
  rounded?: boolean;
}

const FiltersButton: React.FC<FiltersButtonProps> = ({ classes, color = 'default', rounded = false }) => {
  const { toggleDialogOpen, hasFiltersApplied, isFilterLocked } = useDialogContext();

  const handleOpenFitlers = () => {
    toggleDialogOpen();
  };

  return (
    <Button
      classes={{
        label: classnames(classes.filtersButtonLabel, { [classes.filtersLabelLocked]: isFilterLocked }),
        root: classnames(classes.filtersButton, {
          [classes.filtersSelected]: color === 'default' && (isFilterLocked || hasFiltersApplied),
          [classes.filtersSelectedSecondary]: color === 'secondary' && (isFilterLocked || hasFiltersApplied),
          [classes.rounded]: rounded,
        }),
      }}
      disableFocusRipple
      disableRipple
      size="large"
      variant="outlined"
      onClick={handleOpenFitlers}
    >
      <FilterListIcon fontSize={isFilterLocked ? 'default' : 'small'} className={classes.filtersButtonIcon} />
      {isFilterLocked && <LockIcon className={classes.lockedFiltersIcon} />}
      Filters
    </Button>
  );
};

export default withStyles(styles)(FiltersButton);
